import { render } from "./CreatePlaylistWindow.vue?vue&type=template&id=4945bbfd&scoped=true"
import script from "./CreatePlaylistWindow.vue?vue&type=script&lang=js"
export * from "./CreatePlaylistWindow.vue?vue&type=script&lang=js"

import "./CreatePlaylistWindow.vue?vue&type=style&index=0&id=4945bbfd&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4945bbfd"]])

export default __exports__